import { uid } from '../../../utils/random';
import { request as addBet } from './add-bet';

export function request(userId, leg) {
    console.info('addLeg userId, leg', {userId, leg});

    leg = { ...leg, uid: leg.uid ? leg.uid : uid() };

    if (leg.price && leg.price.f) {
        leg.price = leg.price.f;
    }

    if (leg.priceType === 'fp') {
        leg.priceType = !leg.price && leg.isMarketSp ? 'sp' : 'fp';
    } else {
        leg.priceType = leg.priceType === 'sp' && leg.isMarketSp ? 'sp' : 'fp';
    }

    return (dispatch) => {
        dispatch({
            type: 'BETSLIP_ADD_LEG',
            userId,
            leg
        });

        dispatch({
            type: 'BETSLIP_PLACE_BET_CLEAR',
            userId
        });

        dispatch(addBet(
            userId,
            {
                type: 'SGL',
                name: 'Single',
                numLines: 1,
                stakePerLine: 0,
                eachWay: leg.eachWay ?? false,
                legs: [
                    leg.uid
                ]
            }
        ));
    };
}
